import type { KpiKey } from '@klareospace/pharos-lib-types';
import { KPI_GRANULARITY, KPI_KEYS } from '@klareospace/pharos-lib-types';

import type { GetDriverKpisDayParams, GetKpisMtdParams, GetOrderKpisDayParams } from './kpis.api';

export const kpiKeys = {
  all: ['kpis'] as const,
  day: (params: GetOrderKpisDayParams): readonly unknown[] =>
    [...kpiKeys.all, KPI_KEYS.ORDER_KPIS, 'day', params] as const,
  driverDay: (params: GetDriverKpisDayParams): readonly unknown[] =>
    [...kpiKeys.all, KPI_KEYS.DRIVER_TASK_KPIS, 'day', params] as const,
  /** Shared by every `mtd`-granularity KPI key (`order-kpis`, `driver-task-kpis`). */
  mtd: (key: KpiKey, params: GetKpisMtdParams): readonly unknown[] =>
    [...kpiKeys.all, key, KPI_GRANULARITY.MONTH_TO_DATE, params] as const,
};
